module.exports = __webpack_public_path__ + "img/header.ce4b7955.png";